/**
 * AccessDemonstration — the §7001(c) "reasonable demonstration of access" gate (CB-5.3, FR-48(v)).
 *
 * Legal load-bearing mechanic: the signer must actively OPEN and review the document before consent
 * can complete. Without it, the §7001(c) safe harbor is lost (review-legal A2). As of CB-5.4 this
 * embeds the real CeremonyDocumentViewer — reviewing to the end of the document (`onReviewed`)
 * satisfies the gate. It is a CONTROLLED gate (`satisfied` + `onDemonstrated`) owned by ConsentGate.
 */

import { Check } from 'lucide-react';
import CeremonyDocumentViewer from './CeremonyDocumentViewer';

interface AccessDemonstrationProps {
  /** Per-signer access_token — the viewer uses it to fetch the token-scoped signed document URL. */
  token: string;
  /** Whether access has already been demonstrated (owned by the parent ConsentGate). */
  satisfied: boolean;
  /** Called when the signer reaches the end of the document (demonstration of access). */
  onDemonstrated: () => void;
  accent: string;
}

export default function AccessDemonstration({ token, satisfied, onDemonstrated, accent }: AccessDemonstrationProps) {
  return (
    <div className="mt-4" data-ceremony-slot="document-review" aria-label="Document access">
      <p className="mb-2 text-sm text-slate-600">
        Scroll through the document below to confirm you can open and view it.
      </p>
      <CeremonyDocumentViewer
        token={token}
        accent={accent}
        onReviewed={onDemonstrated}
        maxHeightClass="max-h-[55vh]"
      />
      {satisfied ? (
        <p className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-emerald-700">
          <Check className="h-4 w-4" aria-hidden="true" />
          You reviewed the document.
        </p>
      ) : null}
    </div>
  );
}
